import { Box, Button, Dialog, Theme, Typography } from "@mui/material";
import { FailureIcon, SuccessIcon } from "../../assets/SvgIcons";

export interface StatusPopupProps {
    open: boolean;
    isSuccess: boolean;
    title?: string;
    message: string;
    buttonText?: string;
    onButtonClick: (action: string) => void;
}

export default function StatusPopup({
    open,
    isSuccess,
    title,
    message,
    buttonText = "Done",
    onButtonClick,
}: StatusPopupProps): JSX.Element {
    const defaultTitle = isSuccess ? "Success!" : "Failed!";

    return (
        <Dialog
            aria-labelledby="fee-setup-status-popup"
            open={open}
            PaperProps={{
                sx: (theme: Theme) => ({
                    maxWidth: "550px",
                    width: "100%",
                    borderRadius: "12px",
                    padding: "32px 24px 24px",
                    backgroundColor: theme.palette.common.white,
                }),
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    rowGap: "12px",
                    padding: "15px",
                }}
            >
                {isSuccess ? <SuccessIcon width="40" height="40" /> : <FailureIcon width="35" height="35" />}
                <Typography
                    id="status-popup"
                    variant="h2"
                    sx={(theme: Theme) => ({
                        lineHeight: "25px",
                        letterSpacing: "0.01px",
                        color: theme.palette.text.primary,
                    })}
                >
                    {title || defaultTitle}
                </Typography>
                <Typography
                    variant="subtitle_400"
                    sx={(theme: Theme) => ({
                        lineHeight: "22px",
                        letterSpacing: "0.02px",
                        color: theme.palette.text.secondary,
                        textAlign: "center",
                        paddingLeft: "10px",
                        paddingRight: "10px",
                        marginTop: "10px"
                    })}
                >
                    {message}
                </Typography>
            </Box>
            <Box sx={{ padding: "0px", marginTop: "32px" }}>
                <Button
                    fullWidth
                    variant="contained"
                    onClick={() => onButtonClick(isSuccess ? "navigate" : "")}
                    sx={(theme: Theme) => ({
                        ...theme.typography.body_500,
                        fontWeight: 600,
                        lineHeight: "20px",
                        color: theme.palette.common.white,
                        borderRadius: "4px",
                        padding: "13px 20px",
                        backgroundColor: theme.palette.primary[500],
                    })}
                >
                    {buttonText}
                </Button>
            </Box>
        </Dialog>
    );
}
